import React from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { fancyTimeFormat } from "../../Js/TimeAndDate";
import { makeStyles } from '@material-ui/core/styles';

const TrainerDetailTable = (props) => {
    const styles = useStyles();
    // console.log("props.tableDetailData=====>",props.tableDetailData);
    return (
        <TableContainer sx={{
            height: '50vh',
            overflow: 'auto',
            pr: 2
        }}
            className={styles.scrollBar}>
            <Table >
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ color: '#DB8829', fontSize: '1rem', fontWeight: '600', padding: '5px', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                            Item
                        </TableCell>
                        <TableCell align="center" sx={{ color: '#DB8829', fontSize: '1rem', fontWeight: '600', padding: '1px', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                            Duration
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.tableDetailData.length > 0 &&
                        props.tableDetailData.map((detailData, index) => {
                            return (
                                <TableRow
                                    key={index}>
                                    <TableCell sx={{ color: '#DB8829', fontSize: '0.9rem', fontWeight: '500', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1.2rem' } }}>
                                        {detailData.title}
                                    </TableCell>
                                    <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.9rem', fontWeight: '500', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1.2rem' } }}>
                                        {fancyTimeFormat(detailData.sum) + ' m'}
                                    </TableCell>
                                </TableRow>
                            );
                        }
                        )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
const useStyles = makeStyles({
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.5em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    }
});
export default TrainerDetailTable;
